<div>
  <app-message [service]="messageService"></app-message>

  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
    <div class="form-group">
      <label for="name" i18n="@@RfidTagLabel">RFID-Kartennummer</label>
      <input type="text" id="idTag" (input)="onInput($event)" formControlName="idTag" class="form-control"
             i18n-placeholder="@@RfidTagPlaceholder" placeholder="RFID-Kartennummer" ngbautofocus />
      <div class="error">
        <em *ngIf="formService.validateControl('idTag') && formService.hasError('idTag', 'required')"
            i18n="@@RfidTagRequiredErrorMessage">RFID-Kartennummer wird benötigt</em>
      </div>
      <div class="alert-info text-muted p-2 mt-2">Die Kartennummer wird automatisch in Kleinbuchstaben konvertiert um eine bessere Kompatibilät zu erreichen.</div>
    </div>
  </form>
</div>
